import React, { Component, Fragment } from 'react';
import isEmpty from '../../../../utils/helpers';
import {trans} from "../../../../utils/helpers";
import Loader from '../../../../components/common/Spinners/Loader';
import PlanList from './PlanList';
import PackageTooltip from "../../../../components/PackageTooltip";

class ServiceDetailsStep extends Component {

	state = {
		toggledDescription: []
	};

	handleShowHideDescription = (type) => {
		const { toggledDescription } = this.state;

		if (toggledDescription.includes(type)) {
			this.setState({
				toggledDescription: toggledDescription.filter((x) => x !== type)
			});
		}
		else {
			this.setState({
				toggledDescription: [...toggledDescription, type]
			});
		}
	};

	render() {

		const {
			toggledDescription,
		} = this.state;

		const {
			plansDetails,
			planDetailsError,
			values,
			setFieldValue,
			handleChangeStep,
			handleBackStep,
		} = this.props;

		return (
			<>
				{(isEmpty(plansDetails) && planDetailsError === '')
				?
				<Loader />
				:
				<div className="form-section">

					<h4>{trans('en-us', 'signupToServiceScreen.serviceDetails.title')}</h4>

					<p className="form-divider">
						<i className="fas fa-map-marker-alt" /> {values.formatedAddress}
					</p>

					<p className="text-center text-xs text-muted d-block d-sm-none">Scroll down to see map</p>

					<div className="card-product">

						<div className="card-body">

							{planDetailsError && (
								<div className="alert alert-info">{planDetailsError}. We cannot process your request at this moment. Please try again later.</div>
							)}

							{!isEmpty(plansDetails) &&
								plansDetails.map((plan) => (
									<PlanList
										key={plan.id}
										planInfo={plan}
										planIndex={values.order.plans.findIndex((x) => x.planId === plan.id)}
										{...this.props}
									/>
								))}

							<div className="product-price">

								<div className="package">
									<div className="package-header">

										<span className="package-left">One-time:</span>

										<span className="package-right">

											${values.order.plans
												.reduce((acc, currentValue, index) => {
													currentValue.servicelines.map((serviceline) => {
														serviceline.features.map((feature) => {
															if (feature.featureType === 'ACTIVATION') {
																acc += feature.oneTimePrice;
															}
														});
													});
												return acc;
											}, 0)
											.toFixed(2)
											.replace(/\d(?=(\d{3})+\.)/g, '$&,')}

											<button
												type="button"
												className={'btn btn-toggle-package-desc' + (toggledDescription.includes('oneTime') ? ' toggled' : '')}
												onClick={() => this.handleShowHideDescription('oneTime')}
											>
												<i className="fas fa-info-circle" />
											</button>

										</span>

									</div>

									<PackageTooltip color={'white'} isVisible={toggledDescription.includes('oneTime')}>
										{trans('en-us', 'signupToServiceScreen.serviceDetails.oneTimeDescription')}
									</PackageTooltip>

								</div>

								<div className="package">
									<div className="package-header">

										<span className="package-left">Recurring:</span>

										<span className="package-right">

											${values.order.plans
												.reduce((acc, currentValue, index) => {
													currentValue.servicelines.map((serviceline) => {
														serviceline.features.map((feature) => {
															if (feature.featureType !== 'ACTIVATION') {
																acc += feature.recurringMonthlyPrice;
															}
														});
													});
												return acc;
											}, 0)
											.toFixed(2)
											.replace(/\d(?=(\d{3})+\.)/g, '$&,')}/mo

											<button
												type="button"
												className={
													toggledDescription.includes('reccuring') ? (
														'btn btn-toggle-package-desc toggled'
													) : (
														'btn btn-toggle-package-desc'
													)
												}
												onClick={() => this.handleShowHideDescription('reccuring')}
											>
												<i className="fas fa-info-circle" />
											</button>

										</span>

									</div>

									<PackageTooltip color={'white'} isVisible={toggledDescription.includes('reccuring')}>
										{trans('en-us', 'signupToServiceScreen.serviceDetails.reccuringDescription')}
									</PackageTooltip>

								</div>

							</div>
						</div>

						<div className="card-footer">

							<button
								onClick={() => handleBackStep('select-service', setFieldValue)}
								type="button"
								className="btn btn-quick"
							>
								Back
							</button>

							{!planDetailsError && (
								<button
									onClick={() => handleChangeStep('schedule-appointment')}
									type="button"
									className="btn btn-primary"
								>
									Continue
								</button>
							)}

						</div>

					</div>

				</div>
				}
			</>
		);
	}
}

export default ServiceDetailsStep;
